import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Lock, KeyRound } from "lucide-react";
import { useAuth, hasAdminSession } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Backoffice() {
  const { user, adminLogin } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", pin: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => { if (hasAdminSession(user)) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await adminLogin(form.email.trim(), form.password, form.pin.trim());
      nav("/admin", { replace: true });
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-4" style={{ background: "#0f1b17" }}>
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-6 text-white/90">
          <ShieldCheck size={22} aria-hidden="true" />
          <span className="font-extrabold tracking-wide">Washly · Backoffice</span>
        </div>
        <form onSubmit={submit} className="rounded-[24px] bg-white p-6 md:p-8 space-y-4 shadow-2xl" data-testid="backoffice-form">
          <div>
            <h1 className="text-2xl font-extrabold">Geschützter Zugang</h1>
            <p className="w-muted text-sm mt-1">Nur für autorisiertes Washly-Team. Alle Zugriffe werden protokolliert.</p>
          </div>
          <label className="block"><span className="w-label">E-Mail</span>
            <input className="w-input" type="email" required value={form.email} onChange={set("email")} autoComplete="username" data-testid="bo-email" /></label>
          <label className="block"><span className="w-label">Passwort</span>
            <input className="w-input" type="password" required value={form.password} onChange={set("password")} autoComplete="current-password" data-testid="bo-password" /></label>
          <label className="block"><span className="w-label flex items-center gap-1"><KeyRound size={14} aria-hidden="true" /> Backoffice-PIN</span>
            <input className="w-input tracking-[0.5em] font-mono text-center" inputMode="numeric" required minLength={4} maxLength={12}
              value={form.pin} onChange={(e) => setForm({ ...form, pin: e.target.value.replace(/\D/g, "") })} placeholder="••••••" data-testid="bo-pin" /></label>
          {error && <p role="alert" className="font-semibold text-[var(--w-error)]" data-testid="bo-error">{error}</p>}
          <button className="w-btn w-btn-primary w-full" disabled={busy} data-testid="bo-submit"><Lock size={18} aria-hidden="true" /> {busy ? "Prüfe…" : "Anmelden"}</button>
          <p className="w-muted text-xs text-center">Nach 5 Fehlversuchen wird der Zugang für 15 Minuten gesperrt.</p>
        </form>
      </div>
    </div>
  );
}
